export default __webpack_public_path__ + "static/media/slidecompus3.26329701.png";